import React from "react";
import { BEM } from "helpers/BEM.helper";
import { FetchDesignFormInputFieldError } from "../FetchDesignFormInputField/FetchDesignFormInputField";
import { FetchDesignSelectSelectors } from "./FetchDesignSelectSelectors";
import Select from "react-select";

const classes = new BEM({
  block: { name: "FetchDesignSelect" },
  elements: [
    { name: "container" },
    { name: "label", extras: ["fds-emphasis-100"] },
    { name: "menu" },
    { name: "menu-item" },
    { name: "caret" },
  ],
});

export type FetchDesignSelectOptionType = {
  value: string | number;
  label: string;
};

export type FetchDesignSelectProps = {
  options: FetchDesignSelectOptionType[];
  error?: FetchDesignFormInputFieldError;
  onChange?: (selection: FetchDesignSelectOptionType | null) => void;
  labelText?: string;
  defaultText?: string;
  value?: FetchDesignSelectOptionType | null;
  containerStyle?: React.CSSProperties;
  menuStyle?: React.CSSProperties;
  menuItemStyle?: React.CSSProperties;
  ["data-cy"]?: string;
  onInputChange?: (value: string) => void;
  isSearchable?: boolean;
  isClearable?: boolean;
  disabled?: boolean;
  className?: string;
  name?: string;
};

const FetchDesignSelect: React.FC<FetchDesignSelectProps> = (
  props: FetchDesignSelectProps,
) => {
  const {
    options,
    error,
    onChange,
    labelText,
    defaultText,
    value,
    isSearchable = true,
    isClearable = false,
    onInputChange,
    disabled,
    className,
    name,
  } = props;
  const defaultDisplayText = defaultText || "Select...";

  return (
    <div data-cy={props["data-cy"] || FetchDesignSelectSelectors.block}>
      {labelText && (
        <label
          className={classes.getElementClassNames("label")}
          htmlFor={defaultText}
        >
          {labelText}
        </label>
      )}
      <Select
        classNamePrefix={FetchDesignSelectSelectors.block}
        className={className}
        name={name}
        value={value ?? null}
        options={options}
        onChange={(selection) => {
          if (onChange) {
            onChange(selection);
          }
        }}
        placeholder={defaultDisplayText}
        isSearchable={isSearchable}
        isClearable={isClearable}
        onInputChange={onInputChange}
        closeMenuOnSelect={true}
        getOptionValue={(option) => option.value.toString()}
        getOptionLabel={(option) => option.label}
        isDisabled={!!disabled}
      />

      {error && (
        <span
          data-cy={FetchDesignSelectSelectors.error}
          className="fds-color-red-700"
        >
          {error.message}
        </span>
      )}
    </div>
  );
};

export default FetchDesignSelect;
